import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import fbk from "../assets/icons/facebooklogo.svg"; // Assuming you want to reuse this
import touchPhone from "../assets/icons/touchphone.svg";
import headEmail from "../assets/icons/email.svg";

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.contactInfo}>
          <h4>Contact Us</h4>
          <div className={styles.contactLinks}>
            <a
              className={styles.contactLink}
              href="sms:0413119343;?body=Suburb:%0D%0AService required:%0D%0AVehicle make/model:"
            >
              <img className={styles.icon} src={touchPhone} alt="phone" />
              SMS: 0413 119 343
            </a>
            <a
              href="mailto:mauromassaribr@gmail.com"
              className={styles.contactLink}
            >
              <img className={styles.icon} src={headEmail} alt="Email Icon" />
              mauromassaribr@gmail.com
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100075687891593"
              className={styles.contactLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className={styles.icon} src={fbk} alt="Facebook Logo" />
              Facebook
            </a>
          </div>
        </div>
        <div className={styles.quickLinks}>
          <h4>Quick Links</h4>
          <Link to="/" className={styles.footerLink}>
            Home
          </Link>
          <Link to="/about" className={styles.footerLink}>
            About Us
          </Link>
          <Link to="/reviews" className={styles.footerLink}>
            Reviews
          </Link>
          <Link to="/gallery" className={styles.footerLink}>
            Gallery
          </Link>
          <Link to="/contact" className={styles.footerLink}>
            Contact
          </Link>
        </div>
        <div className={styles.legal}>
          <h4>Legal</h4>
          <Link to="/privacy-policy" className={styles.footerLink}>
            Privacy Policy
          </Link>
          <a
            href="https://ols.demirs.wa.gov.au/search"
            className={styles.footerLink}
          >
            MRB License: MRB12393
          </a>
          <p className={styles.footerLink}>RTA License: AU066483</p>
        </div>
      </div>
      <div className={styles.copyright}>
        &copy; {new Date().getFullYear()} Massari Auto Service. All Rights
        Reserved.
        <br />
        <p>ABN 55 687 375 846</p>
      </div>
    </footer>
  );
};
